// Shared countries configuration
const COUNTRIES = [
  { code: 'sn', name: 'Sénégal', flag: '🇸🇳', available: true },
  { code: 'ci', name: "Côte d'Ivoire", flag: '🇨🇮', available: true },
  { code: 'ne', name: "Niger", flag: '🇳🇪', available: false },
  { code: 'cm', name: "Cameroun", flag: '🇨🇲', available: false },
];

export default COUNTRIES;
